<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_shift_form_editTitle')
        : $t('label_essweb_shift_form_viewTitle')
    "
    pad="0"
    widthClass="max-1000"
    :delBtn="hasBtn('delete-admin-shift')"
    :editBtn="!iSEdited && hasBtn('edit-admin-shift')"
    @edit="iSEdited = true"
    :initData="shiftData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'shift_name',
      'sequence',
      'shift_description',
      'shift_abbr',
      'start_utc_time',
      'end_utc_time',
      'shift_type_uuid',
      'shift_code',
      'default_site_uuid',
      'total_working_minutes',
      'color_code',
      'effective_utc_datetime',
      'expired_utc_datetime',
      'shift_property_group_uuid',
      'remarks',
    ]"
    @delete="
      $confirmDo($t('label_essweb_shift_list_title')).then((res) => {
        res ? toDeleteShift() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation class="pa-2">
            <v-row class="white lighten-5">
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :bindData="shiftData.shift_name"
                  @change="
                    (valueArr) => {
                      shiftData.shift_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_shift_form_shiftNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <!-- 2020-09-03修改为非国际化 -->
                <normalInputTextFiled
                  :label="$t('label_essweb_shift_form_shiftAbbrLabel')"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  v-model="shiftData.shift_abbr"
                  :placeholder="$t('label_essweb_shift_form_shiftAbbrLabel')"
                  dense
                />
              </v-col>
              <v-col xs="12" sm="4" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="shiftData.shift_code"
                />
              </v-col>
              <v-col xs="12" sm="4" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_shift_form_sequenceLabel')"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  type="number"
                  :rules="$GetRules(['_Number_negative'], [null])"
                  v-model="shiftData.sequence"
                />
              </v-col>
              <v-col xs="12" sm="4" md="4" lg="4" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_shift_form_tagColorLabel")
                }}</v-sheet>
                <SelectColor
                  :items="Colors"
                  v-model="shiftData.color_code"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :appendIcon="iSEdited ? 'arrow_drop_down' : ''"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="shiftData.shift_description"
                  @change="
                    (valueArr) => {
                      shiftData.shift_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_shift_form_descriptionLabel')"
                />
              </v-col>

              <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="px-1">
                <Tabler :headers="headers" :items="desserts" border>
                  <template v-slot:item.type="{ item }">
                    {{ $getCommonLangValue(item.event_type_name) }}
                  </template>
                  <template v-slot:item.name="{ item }">
                    {{ $getCommonLangValue(item.event_business_name) }}
                  </template>
                  <template v-slot:item.startTime="{ item }">
                    {{ $timeMachine(item.start_utc_time) }}
                  </template>
                  <template v-slot:item.endTime="{ item }">
                    {{ $timeMachine(item.end_utc_time) }}
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{
                      Number(item.end_utc_time) - Number(item.start_utc_time)
                    }}
                    {{ $t("label_essweb_system_minutesLabel") }}
                  </template>
                  <template v-slot:item.group="{ item }">
                    <v-btn icon @click="toViewProperty(item)">
                      <span class="material-icons-round">search</span>
                    </v-btn>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      icon
                      small
                      v-if="iSEdited && false"
                      @click="toEditMapping(item)"
                      :disabled="!iSEdited"
                    >
                      <span class="material-icons-round">edit</span>
                    </v-btn>

                    <v-btn
                      icon
                      v-if="iSEdited"
                      @click="toDelete(item)"
                      :disabled="!iSEdited"
                    >
                      <span class="material-icons-round">delete</span>
                    </v-btn>
                  </template>
                  <template v-slot:footer v-if="iSEdited">
                    <v-divider></v-divider>
                    <v-btn
                      text
                      :disabled="!iSEdited"
                      color="primary"
                      class="text-capitalize my-2 text-button"
                      @click="toNewMapping"
                    >
                      {{ $t("label_essweb_shift_form_addEventBtnLabel") }}
                      <span class="material-icons-round">add</span>
                    </v-btn>
                  </template>
                </Tabler>
                <v-sheet class="text--secondary pl-1 text-left"
                  >{{
                    $t("label_essweb_shift_form_totalMinutesLabel") + " "
                  }}:{{ totalMin
                  }}{{ $t("label_essweb_system_minutesLabel") }}</v-sheet
                >
              </v-col>

              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <AutoComplete
                  isRequired
                  :items="ShiftTypeList"
                  item-text="shift_type_name"
                  label="label_essweb_shift_form_shiftTypeLabel"
                  :filled="iSEdited"
                  item-value="uuid"
                  :readonly="!iSEdited"
                  chips
                  small-chips
                  :rules="$GetRules(['_Require_ArrRules'], [null])"
                  multiple
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  deletable-chips
                  v-model="shiftData.shift_type_uuid"
                >
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.shift_type_name) }}
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{ $getCommonLangValue(data.item.shift_type_name) }}
                  </template>
                </AutoComplete>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <AutoComplete
                  :items="defaultSiteList"
                  item-text="site_name"
                  label="label_essweb_shift_form_siteNameLabel"
                  item-value="uuid"
                  chips
                  small-chips
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  deletable-chips
                  v-model="shiftData.default_site_uuid"
                >
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.site_name) }}
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{ $getCommonLangValue(data.item.site_name) }}
                  </template>
                </AutoComplete>
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <DateTimePicker
                  type="date"
                  placeholder="YYYY/MM/DD"
                  :filled="iSEdited"
                  :label="$t('label_essweb_shift_form_effectiveDateLabel')"
                  :defaultTime="shiftData.effective_utc_datetime"
                  :max="shiftData.expired_utc_datetime"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  @change="
                    (time) => {
                      shiftData.effective_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <DateTimePicker
                  :min="shiftData.effective_utc_datetime"
                  :defaultTime="shiftData.expired_utc_datetime"
                  :label="$t('label_essweb_shift_form_expireDateLabel')"
                  @change="
                    (time) => {
                      shiftData.expired_utc_datetime = time;
                    }
                  "
                  type="date"
                  placeholder="YYYY/MM/DD"
                  :filled="iSEdited"
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_shift_form_timeZoneLabel")
                }}</v-sheet>
                <v-select
                  :items="staticZone"
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                  item-text="text"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  item-value="utc"
                  v-model="shiftData.expired_time_zone"
                  :label="$t('label_essweb_shift_form_timeZoneLabel')"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template>
                </v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <AutoComplete
                  isRequired
                  :items="ShiftPorpertyGroup"
                  item-text="shift_property_group_name"
                  item-value="uuid"
                  label="label_essweb_shift_form_shiftPropertyGroupLabel"
                  v-model="shiftData.shift_property_group_uuid"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :readonly="!iSEdited"
                  small-chips
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :placeholder="
                    $t('label_essweb_shift_form_shiftPropertyGroupLabel')
                  "
                >
                  <template v-slot:selection="{ data }">
                    {{
                      $getCommonLangValue(data.item.shift_property_group_name)
                    }}
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{
                      $getCommonLangValue(data.item.shift_property_group_name)
                    }}
                  </template>
                </AutoComplete>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-sheet
            class="max-width pa-3 d-flex flex-row justify-space-between"
            height="50"
          >
            <div class="title">
              {{ $t("label_essweb_shift_form_step_punchMethodLabel") }}
            </div>
            <v-spacer></v-spacer>
            <div class="text-right align-right">
              <v-btn
                rounded
                outlined
                v-if="iSEdited"
                :disabled="!iSEdited"
                text
                class="text-capitalize mx-2"
                color="primary"
                @click="toCopyFromShift"
                >{{ $t("label_essweb_shift_form_copyFromAnotherShift") }}</v-btn
              >
              <v-btn
                rounded
                outlined
                text
                v-if="iSEdited"
                :disabled="!iSEdited"
                class="text-capitalize mx-2"
                color="primary"
                @click="toAddGroup"
                >{{ $t("label_essweb_shift_form_addSiteBtnLabel")
                }}<span class="material-icons-round">add</span></v-btn
              >
            </div>
          </v-sheet>
          <noContent v-if="!SiteMappingData.length" />
          <SpecialTable
            isHead
            :readonly="!iSEdited"
            :headers="siteHeader"
            showFooter
            :key="index"
            v-for="(item, index) in SiteMappingData"
            :tableTitle="item.site_name"
            type="site"
            :type_uuid="item.site_uuid"
            @onNew="toAddCriteriaType"
            @onDelete="toDeleteCriteriaType"
            @onDeleteGroup="toDeleteGroup(item.site_uuid)"
            :items="item.items ? item.items : []"
            newBtn="label_essweb_shift_form_criteriaTypeLabel"
          />
        </template>
      </Taber>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->

    <!-- tools -->
    <template v-slot:tools-main>
      <newCriteriaTypeDialog
        :show="showCriteriaTypeDialog"
        :site="curSite"
        @close="showCriteriaTypeDialog = false"
        @new="onNewCriteriaType"
      />
      <mapEventShift
        :show="mapToDialog"
        :action="curAction"
        @closeDialog="mapToDialog = false"
        :mapData="curMapData"
        @new="onNewMapping"
        @edit="onEditMapping"
      />
      <newGroupMapping
        :show="newGroupMapDialog"
        @new="toNewGroup"
        @close="newGroupMapDialog = false"
      />
      <copyFromShift
        :show="showCopyShift"
        :curentShift="$route.params.id"
        @close="showCopyShift = false"
        @new="onCopyFromShift"
      />
      <viewProperty
        :show="showPropertyList"
        @close="showPropertyList = false"
        :group_uuid="curGroupUuid"
      />
    </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import mapEventShift from "@/Page/EssAdmin/Shift/ShiftList/components/mapEventShift";
import viewProperty from "@/Page/EssAdmin/Shift/ShiftList/components/viewProperty";
import newGroupMapping from "@/Page/EssAdmin/Shift/ShiftList/components/newGroupMapping";
import copyFromShift from "@/Page/EssAdmin/Shift/ShiftList/components/copyFromShift";
import newCriteriaTypeDialog from "@/Page/EssAdmin/Shift/ShiftList/components/newCriteriaTypeDialog";
import { mapGetters } from "vuex";

export default {
  name: "newShift",
  components: {
    mapEventShift,
    newCriteriaTypeDialog,
    copyFromShift,
    newGroupMapping,
    viewProperty,
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    curCriteriaTypeList() {
      var arr = [];
      this.SiteMappingData.forEach((item, index) => {
        item.items.forEach((it, index) => {
          arr.push({
            site_uuid: item.site_uuid,
            criteria_type_uuid: it.criteriaType.uuid,
            criteria_uuid: it.criteria ? it.criteria.uuid : "",
            is_required: 1,
            remarks: "",
          });
        });
      });
      return arr;
    },
    timeTerminal() {
      return this.getTimeTerminal();
    },
    totalMin() {
      let total = 0;
      this.desserts.map((item) => {
        total += Number(item.total_minutes);
      });
      return total;
    },
    ShiftTypeList() {
      return this.$getSelectTrans(this.ShiftTypeListData, "shift_type_name");
    },
    defaultSiteList() {
      return this.$getSelectTrans(this.defaultSiteListData, "site_name");
    },
    costCenter() {
      return this.$getSelectTrans(this.costCenterData, "view_fields");
    },
    ShiftPorpertyGroup() {
      return this.$getSelectTrans(
        this.ShiftPorpertyGroupData,
        "shift_property_group_name"
      );
    },
  },
  created() {
    this.getBtnPermissionList();
  },
  watch: {},
  mounted() {
    const that = this;
    this.getColors();
    this.getType();
    this.getCostCenter();
    this.getDefaultSiteList();
    this.getPorpertyGroup();
    this.getShiftDetailsByUuid();
    this.getShiftMappingListByUuid();
    this.getCriteriaSiteList();
  },
  data() {
    return {
      Colors: [],
      isLoading: false,
      isChanged: false,
      defaultSiteListData: [],
      costCenterData: "",
      curGroupUuid: null,
      showPropertyList: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_shift_form_step_generalLabel",
        "label_essweb_shift_form_step_punchMethodLabel",
      ],
      curItem: null,
      iSEdited: false,
      curAction: "new",
      curSiteUuid: null,
      curSite: null,
      curMapData: null,
      curUuid: null,
      showCriteriaTypeDialog: false,
      newGroupMapDialog: false,
      showCopyShift: false,
      mapToDialog: false,
      siteHeader: [
        {
          text: "label_essweb_shiftform_event_list_eventTypeLabel",
          value: "type",
          width: 400,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shiftform_event_list_eventNameLabel",
          value: "name",
          width: 400,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      SiteMappingData: [],
      shiftData: {
        uuid: null,
        shift_name: "",
        sequence: 1,
        shift_description: "",
        shift_abbr: "",
        shift_code: "",
        shift_type_uuid: [],
        start_utc_time: "",
        start_time_time_zone: "",
        // cost_center_uuid: "",
        end_utc_time: "",
        end_time_time_zone: "",
        total_working_minutes: "",
        default_site_uuid: "",
        color_code: "",
        effective_utc_datetime: "",
        effective_time_zone: 0,
        expired_utc_datetime: "",
        expired_time_zone: 0,
        shift_property_group_uuid: "",
        remarks: "",
      },
      search: "",
      showSelect: false,
      selected: [],
      page: 1,
      headers: [
        {
          text: "label_essweb_event_list_eventTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_eventNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_startTimeLabel",
          value: "startTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_endTimeLabel",
          value: "endTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_totalMinutesLabel",
          value: "total",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_form_eventPropertyGroupLabel",
          value: "group",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftActionsLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      ShiftTypeListData: [],
      ShiftPorpertyGroupData: [],
    };
  },
  methods: {
    getColors() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_color_shift_select",
      }).then((res) => {
        that.Colors = [];
        res.data.map((item) => {
          that.Colors.push({
            text: item.view_fields,
            color: item.value_field,
          });
        });
      });
    },
    getCostCenter: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_cost_center_select",
      }).then((res) => {
        that.costCenterData = res.data;
      });
    },
    removeType: function (item) {
      const index = this.shiftData.shift_type_uuid.indexOf(item.uuid);
      if (index >= 0) this.shiftData.shift_type_uuid.splice(index, 1);
    },
    toViewProperty: function (item) {
      if (item["event_property_group_uuid"]) {
        this.curGroupUuid = item["event_property_group_uuid"];
        this.showPropertyList = true;
      }
    },
    toCopyFromShift: function () {
      this.showCopyShift = true;
    },
    onCopyFromShift: function (sitelist) {
      const that = this;
      var arr = [];
      sitelist.forEach((item, index) => {
        item.items.forEach((it, index) => {
          arr.push({
            site_uuid: item.site_uuid,
            criteria_type_uuid: it.criteriaType.uuid,
            criteria_uuid: it.criteria ? it.criteria.uuid : "",
            is_required: 1,
            remarks: "",
          });
        });
      });
      this.showCopyShift = false;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/update-shift-table/",
        data: {
          uuid: that.$route.params.id,
          ess_map_punch_criteria_site: arr,
        },
      }).then((res) => {
        that.SiteMappingData = sitelist;
      });
    },
    toAddGroup: function () {
      this.newGroupMapDialog = true;
    },

    toNewGroup: function (site) {
      const that = this;
      this.newGroupMapDialog = false;
      var arr = this.SiteMappingData.filter(
        (ele) => ele.site_uuid === site.uuid
      );
      if (arr.length) {
        that.$showMessage({
          title: that.$t("message_essweb_form_textField_errNoticeTitle"),
          text: that.$t("error_essweb_shift_form_siteExistLabel"),
          okText: that.$t("message_essweb_form_textField_selectAgain"),
          type: "error",
        });
        return;
      } else {
        this.SiteMappingData.push({
          items: [],
          site_abbr: site.site_abbr,
          site_description: site.site_description,
          site_name: site.site_name,
          site_uuid: site.uuid,
        });
      }
    },
    toConfirmDeleteGroup: function () {
      const that = this;
      var curSiteMapping = this.SiteMappingData.filter(
        (ele) => ele.site_uuid === this.curUuid
      )[0];
      if (curSiteMapping.items.length == 0) {
        this.SiteMappingData = this.SiteMappingData.filter(
          (ele) => ele.site_uuid !== this.curUuid
        );
      } else {
        var uuids = [];
        curSiteMapping.items.forEach((item) => {
          uuids.push(item.uuid);
        });
        this.$Request({
          method: "POST",
          table: "ess_map_punch_criteria_site",
          url: "/condition-mapping/delete-condition-mapping-table/",
          data: {
            uuids: uuids.join(","),
          },
        }).then((res) => {
          that.$showMessage({
            text: that.$t(
              "message_essweb_shift_form_deleteSiteGroupSuccessLabel"
            ),
            type: "success",
          });
          that.SiteMappingData = that.SiteMappingData.filter(
            (ele) => ele.site_uuid !== that.curUuid
          );
        });
      }
    },
    toAddCriteriaType: function (type, typeid) {
      this.curSite = typeid;
      this.showCriteriaTypeDialog = true;
    },
    onNewCriteriaType: function (site, obj) {
      const that = this;
      this.showCriteriaTypeDialog = false;
      this.SiteMappingData.some(function (item, index) {
        if (item.site_uuid == site) {
          if (item.items.length <= 0) {
            that
              .$Request({
                method: "POST",
                table: "ess_map_punch_criteria_site",
                url: "/condition-mapping/add-condition-mapping-table/",
                data: {
                  shift_uuid: that.$route.params.id,
                  site_uuid: site,
                  criteria_type_uuid: obj.curCriteria.criteria_type_uuid,
                  criteria_uuid: obj.curCriteria.uuid,
                  is_required: 1,
                  remarks: "",
                },
              })
              .then((res) => {
                item.items.push({
                  site_abbr: obj.curSite.site_abbr,
                  site_description: obj.curSite.site_description,
                  site_name: obj.curSite.site_name,
                  criteriaType: obj.curType,
                  site_uuid: site,
                  criteria: obj.curCriteria,
                  uuid: res.data.uuid,
                });
              });
          } else {
            item.items.some((it, index) => {
              //2021-02-14 开放Wifi可以重复加入 Daveluo
              if (
                it.criteriaType.punch_code !== "WIFI" &&
                it.criteriaType.punch_code == obj.curType.punch_code
              ) {
                that.$showMessage({
                  title: that.$t(
                    "message_essweb_shift_form_criteriaTypeErrorTitle"
                  ),
                  text: that.$t(
                    "error_essweb_shift_form_criteriaTypeExistLabel"
                  ),
                  type: "error",
                });
                return true;
              } else {
                if (index == item.items.length - 1) {
                  that
                    .$Request({
                      method: "POST",
                      table: "ess_map_punch_criteria_site",
                      url: "/condition-mapping/add-condition-mapping-table/",
                      data: {
                        shift_uuid: that.$route.params.id,
                        site_uuid: site,
                        criteria_type_uuid: obj.curCriteria.criteria_type_uuid,
                        criteria_uuid: obj.curCriteria.uuid,
                        is_required: 1,
                        remarks: "",
                      },
                    })
                    .then((res) => {
                      item.items.push({
                        site_abbr: obj.curSite.site_abbr,
                        site_description: obj.curSite.site_description,
                        site_name: obj.curSite.site_name,
                        criteriaType: obj.curType,
                        site_uuid: site,
                        criteria: obj.curCriteria,
                        uuid: res.data.uuid,
                      });
                    });
                }
              }
            });
          }
          return true;
        }
      });
    },
    toDeleteCriteriaType: function (type, obj, site) {
      const that = this;
      this.curUuid = obj.uuid; //
      this.curSiteUuid = site; //
      this.$confirmDo(
        this.$t("label_essweb_shift_form_dialog_criteriaTypeLabel")
      ).then((res) => {
        if (res) that.toConfirmDeleteCriteria();
      });
    },
    toConfirmDeleteCriteria: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_map_punch_criteria_shift",
        url: "/condition-mapping/delete-condition-mapping-table/",
        data: {
          shift_uuid: this.$route.params.id,
          uuids: this.curUuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shift_form_deletecriteriaTypeSuccessLabel"
          ),
          type: "success",
        });
        that.SiteMappingData.some(function (item, index) {
          if (item.site_uuid === that.curSiteUuid) {
            item.items = item.items.filter((ele) => ele.uuid !== that.curUuid);
            return true;
          }
        });
      });
    },
    toDeleteGroup: function (uuid) {
      const that = this;
      this.curUuid = uuid;
      this.$confirmDo(
        this.$t("label_essweb_shift_form_dialog_siteNameLabel")
      ).then((res) => {
        if (res) that.toConfirmDeleteGroup();
      });
    },
    getTimeTerminal: function () {
      if (this.desserts.length == 0) {
        this.shiftData.total_working_minutes = 0;
        return {
          start_time: "0",
          start_utc: this.defaultUTC,
          end_time: "0",
          end_utc: this.defaultUTC,
        };
      } else {
        this.shiftData.total_working_minutes = 0;
        var min = Number(this.desserts[0].start_utc_time),
          minUtc = this.desserts[0].start_time_time_zone,
          maxUtc = this.desserts[0].end_time_time_zone,
          max = Number(this.desserts[0].end_utc_time);
        this.desserts.forEach((item, index) => {
          if (Number(item.start_utc_time) < min) {
            min = Number(item.start_utc_time);
            minUtc = item.start_time_time_zone;
          }
          if (Number(item.end_utc_time) > max) {
            max = Number(item.end_utc_time);
            maxUtc = item.end_time_time_zone;
          }
          this.shiftData.total_working_minutes =
            this.shiftData.total_working_minutes +
            (Number(item.end_utc_time) - Number(item.start_utc_time));
        });
        return {
          start_time: min.toString(),
          start_utc: minUtc,
          end_time: max.toString(),
          end_utc: maxUtc,
        };
      }
    },
    onNewMapping: function (obj) {
      const that = this;
      this.mapToDialog = false;
      this.isLoading = true;
      if (this.desserts.length == 0) {
        that
          .$Request({
            method: "POST",
            table: "ess_att_map_shift_event",
            url: "/shift-mapping/add-shift-mapping-table/",
            data: {
              event_uuid: obj.event_uuid,
              shift_uuid: that.$route.params.id,
              event_type_uuid: obj.type_uuid,
            },
          })
          .then((res) => {
            that.getShiftMappingListByUuid();
            that.isLoading = false;
          })
          .catch((err) => {
            that.isLoading = false;
          });
        return;
      } else {
        // 判断时区
        if (Number(this.timeTerminal.start_utc) != 0) {
          // console.log(obj);
          // console.log(this.timeTerminal);
          if (obj.startUtc != this.timeTerminal.start_utc) {
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_zoneErrorTitle"),
              okText: that.$t("message_essweb_form_textField_selectAgain"),
              text: that.$t("error_essweb_shift_form_zoneOverlapLabel"),
            });
            that.isLoading = false;
            return false;
          }
        }

        this.desserts.some(function (item, index) {
          if (
            item.event_type_uuid == obj.type_uuid &&
            item.uuid == obj.event_uuid
          ) {
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_form_textField_errNoticeTitle"),
              text: that.$t("error_essweb_shift_form_eventExistLabel"),
            });
            that.isLoading = false;
            return true;
          } else if (
            Number(obj.startTime) > Number(item.start_utc_time) &&
            Number(obj.endTime) < Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          } else if (
            Number(obj.startTime) == Number(item.start_utc_time) &&
            Number(obj.endTime) == Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          } else if (
            Number(item.start_utc_time) < Number(obj.startTime) &&
            Number(obj.startTime) < Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          } else if (
            Number(item.start_utc_time) < Number(obj.endTime) &&
            Number(obj.endTime) < Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          }
          if (index == that.desserts.length - 1) {
            that
              .$Request({
                method: "POST",
                table: "ess_att_map_shift_event",
                url: "/shift-mapping/add-shift-mapping-table/",
                data: {
                  event_uuid: obj.event_uuid,
                  shift_uuid: that.$route.params.id,
                  event_type_uuid: obj.type_uuid,
                },
              })
              .then((res) => {
                that.getShiftMappingListByUuid();

                that.isLoading = false;
              })
              .catch((err) => {
                that.isLoading = false;
              });
          }
        });
        //排序
        this.desserts.sort((a, b) => {
          if (a.start_utc_time > b.start_utc_time) {
            return 1;
          } else if (a.start_utc_time == b.start_utc_time) {
            return 0;
          } else {
            return -1;
          }
        });
      }
    },
    onEditMapping: function (obj) {
      // console.log(obj);
      const that = this;
      this.mapToDialog = false;
      var curindex = null;
      // 判断时区
      if (Number(this.timeTerminal.start_utc) != 0) {
        if (obj.startUtc != this.timeTerminal.start_utc) {
          that.$showMessage({
            type: "error",
            title: that.$t("message_essweb_shift_form_zoneErrorTitle"),
            okText: that.$t("message_essweb_form_textField_selectAgain"),
            text: that.$t("error_essweb_shift_form_zoneOverlapLabel"),
          });
          return;
        }
      }
      //some(),当return true 时，跳出循环
      this.desserts.some(function (item, index) {
        if (item.map_uuid != obj.id) {
          if (
            item.event_type_uuid == obj.type_uuid &&
            item.uuid == obj.event_uuid
          ) {
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_form_textField_errNoticeTitle"),
              text: that.$t("error_essweb_shift_form_eventExistLabel"),
            });
            return true;
          }
          if (
            Number(obj.startTime) > Number(item.start_utc_time) &&
            Number(obj.endTime) < Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          }
          if (
            Number(obj.startTime) == Number(item.start_utc_time) &&
            Number(obj.endTime) == Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          }
          if (
            Number(item.start_utc_time) < Number(obj.startTime) &&
            Number(obj.startTime) < Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          }
          if (
            Number(item.start_utc_time) < Number(obj.endTime) &&
            Number(obj.endTime) < Number(item.end_utc_time)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              type: "error",
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            });
            return true;
          }
        } else {
          curindex = index;
        }
        if (index == that.desserts.length - 1) {
          that
            .$Request({
              method: "POST",
              table: "ess_att_map_shift_event",
              url: "/shift-mapping/update-shift-mapping-table/",
              data: {
                event_uuid: obj.event_uuid,
                uuid: obj.id,
                event_type_uuid: obj.type_uuid,
              },
            })
            .then((res) => {
              that.$showMessage({
                text: that.$t(
                  "message_essweb_shift_form_updateEventSuccessLabel"
                ),
                type: "success",
              });
              that.getShiftMappingListByUuid();

              that.isLoading = false;
            })
            .catch((err) => {
              that.isLoading = false;
            });
        }
      });
      //排序
      this.desserts.sort((a, b) => {
        if (a.start_utc_time > b.start_utc_time) {
          return 1;
        } else if (a.start_utc_time == b.start_utc_time) {
          return 0;
        } else {
          return -1;
        }
      });
    },
    getType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/get-shift-type-list/",
      }).then((res) => {
        that.ShiftTypeListData = res.data;
      });
    },
    getDefaultSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
      }).then((res) => {
        that.defaultSiteListData = res.data;
      });
    },
    getPorpertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/get-shift-property-group-list/",
      }).then((res) => {
        that.ShiftPorpertyGroupData = res.data;
      });
    },
    toDelete(item) {
      const that = this;
      this.curItem = item;
      this.$confirmDo(this.$t("label_essweb_event_list_title")).then((res) => {
        if (res) that.toDeleteMapping();
      });
    },
    toDeleteMapping: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_map_shift_event",
        url: "/shift-mapping/delete-shift-mapping-table/",
        data: {
          uuids: this.curItem.map_uuid,
          shift_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t("message_essweb_shift_form_deleteEventSuccessLabel"),
          type: "success",
        });
        that.getShiftMappingListByUuid();
      });
    },
    toEditMapping: function (item) {
      const that = this;
      // console.log(item);
      this.curAction = "edit";
      this.curMapData = { id: null, curType: "", curEvent: "" };
      setTimeout(function () {
        that.curMapData = {
          id: item.map_uuid,
          curType: item.event_type_uuid,
          curEvent: item.uuid,
        };
      }, 300);
      this.mapToDialog = true;
    },
    getCriteriaSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_map_punch_criteria_site",
        url: "/condition-mapping/get-condition-mapping-list/",
        data: {
          shift_uuid: this.$route.params.id,

          searchType: "map",
        },
      }).then((res) => {
        that.SiteMappingData = res.data;
      });
    },
    getShiftMappingListByUuid: function () {
      const that = this;
      this.isLoading = true;
      that.desserts = [];
      this.$Request({
        method: "POST",
        table: "ess_att_map_shift_event",
        url: "/shift-mapping/get-shift-mapping-list/",
        data: {
          shift_uuid: this.$route.params.id,
        },
      })
        .then((res) => {
          // res.data.forEach(function(item) {
          // if (item.event_property_group_uuid.indexOf(",") != -1) {
          //   item.event_property_group_uuid = item.event_property_group_uuid.split(
          //     ","
          //   );
          // } else {
          //   item.event_property_group_uuid =
          //     item.event_property_group_uuid

          // }
          // });

          that.desserts = res.data;
          //排序
          that.desserts.sort((a, b) => {
            if (a.start_utc_time > b.start_utc_time) {
              return 1;
            } else if (a.start_utc_time == b.start_utc_time) {
              return 0;
            } else {
              return -1;
            }
          });
          that.isLoading = false;
        })
        .catch((err) => {
          that.isLoading = false;
        });
    },
    getShiftDetailsByUuid: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/get-shift-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        if (res.data.shift_type_uuid.indexOf(",") != -1) {
          res.data.shift_type_uuid = res.data.shift_type_uuid.split(",");
        } else {
          res.data.shift_type_uuid = [res.data.shift_type_uuid];
        }
        res.data["shift_name_save"] = res.data.shift_name;
        res.data.shift_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.shift_name
        );
        res.data["shift_description_save"] = res.data.shift_description;
        res.data.shift_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.shift_description
        );
        // 2020-09-03修改为非国际化
        // res.data["shift_abbr_save"] = res.data.shift_abbr;
        // res.data.shift_abbr = that.$transOnLineCommonLangKey(
        //   that.companyLang,
        //   res.data.shift_abbr
        // );
        res.data.effective_utc_datetime = this.$getDateTime(
          res.data.effective_utc_datetime,
          "YYYY-MM-DD"
        );
        res.data.expired_utc_datetime = this.$getDateTime(
          res.data.expired_utc_datetime,
          "YYYY-MM-DD"
        );
        that.shiftData = res.data;
      });
    },
    toNewMapping: function () {
      this.curAction = "new";
      this.mapToDialog = true;
      this.curMapData = { id: null, curType: "", curEvent: "" };
    },
    editMappingShift: function (item) {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_map_shift_event",
        url: "/shift-mapping/update-shift-mapping-table/",
        data: {
          uuid: item.uuid,
          event_uuid: item.eventid,
          event_duty_name: item.name,
          event_duty_description: item.description,
          start_utc_time: item.startTime,
          start_time_time_zone: item.startUtc,
          end_utc_time: item.endTime,
          end_time_time_zone: item.endUtc,
          event_type_uuid: item.type.join(","),
          event_property_group_uuid: item.group,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_shift_form_updateEventSuccessLabel"),
          type: "success",
        });
        that.getShiftMappingListByUuid();
      });

      this.mapToDialog = false;
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/update-shift-table/",
        data: {
          uuid: this.$route.params.id,
          sequence: this.shiftData.sequence,
          shift_name: this.$transCommonLangKey(
            this.shiftData.shift_name,
            this.shiftData.shift_name_save
          ),
          shift_description: this.$transCommonLangKey(
            this.shiftData.shift_description,
            this.shiftData.shift_description_save
          ),
          // 2020-09-03修改为非国际化
          // shift_abbr: this.$transCommonLangKey(
          //   this.shiftData.shift_abbr,
          //   this.shiftData.shift_abbr_save
          // ),
          shift_code: this.shiftData.shift_code,
          shift_abbr: this.shiftData.shift_abbr,
          default_site_uuid: this.shiftData.default_site_uuid,
          // cost_center_uuid: this.shiftData.cost_center_uuid,
          shift_type_uuid: this.shiftData.shift_type_uuid.join(","),
          color_code: this.shiftData.color_code,
          effective_utc_datetime: this.$getTimeValue(
            this.shiftData.effective_utc_datetime
          ),
          effective_time_zone: this.shiftData.expired_time_zone, //sync utc
          expired_utc_datetime: this.$getTimeValue(
            this.shiftData.expired_utc_datetime
          ),
          expired_time_zone: this.shiftData.expired_time_zone,
          shift_property_group_uuid: this.shiftData.shift_property_group_uuid,
          remarks: this.shiftData.remarks,
        },
      }).then((res) => {
        that.getShiftDetailsByUuid();
        that.toBack(); //回到不能编辑状态
        that.$showMessage({
          type: "success",
          text: that.$t("message_essweb_shift_form_editShiftSuccessLabel"),
        });
      });
    },
    toEdit: function () {
      this.iSEdited = true;
    },
    toDeleteShift: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/delete-shift-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_shift_form_deleteShiftSuccessLabel"),
          type: "success",
        });
        that.toBack();
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getShiftDetailsByUuid();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getShiftDetailsByUuid();
        } else {
          this.$router.back();
        }
      }
    },
  },
};
</script>
